/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileDto } from '../../models/profile-dto';

export interface ShopGetShopProfile$Params {
  'x-trace-id'?: string;
  id: string;
}

export function shopGetShopProfile(http: HttpClient, rootUrl: string, params: ShopGetShopProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileDto>> {
  const rb = new RequestBuilder(rootUrl, shopGetShopProfile.PATH, 'get');
  if (params) {
    rb.header('x-trace-id', params['x-trace-id'], {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileDto>;
    })
  );
}

shopGetShopProfile.PATH = '/api/shop/profile/{id}';
